import React from 'react'

export function Unexpected() {
  return <p>We’re sorry, something went wrong.</p>
}
